<ng-container *ngIf="!loading">
    <p-dropdown inputId="state" [options]="list" [(ngModel)]="selectedItem" optionLabel="name" [filter]="true"
        filterBy="name" [showClear]="true" [placeholder]="placeHolderLanguage" (onChange)="feedback()"
        [style]="{'width':'100%'}" [disabled]="disabled"></p-dropdown>
</ng-container>
<ng-container *ngIf="loading">
    <div class="col-12">
        Carregando...
    </div>
</ng-container>